var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.19 0H6.81C3.167 0 .997 1.953.997 5.229v7.533C.998 16.047 3.168 18 6.809 18h8.372c3.64 0 5.811-1.953 5.811-5.229V5.229C21.002 1.953 18.832 0 15.191 0z",
    fill: "#1080FF",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m13.261 9-1.51-.477v-3.05h.36c.81 0 1.47.638 1.47 1.421 0 .369.34.675.75.675s.75-.306.75-.675c0-1.53-1.33-2.772-2.97-2.772h-.36V3.6c0-.369-.34-.675-.75-.675s-.75.306-.75.675v.522H9.6c-1.48 0-2.69 1.125-2.69 2.502C6.91 8.235 7.95 8.748 8.74 9l1.51.477v3.042h-.36c-.81 0-1.47-.639-1.47-1.422 0-.369-.34-.675-.75-.675s-.75.306-.75.675c0 1.53 1.33 2.772 2.97 2.772h.36v.531c0 .369.34.675.75.675s.75-.306.75-.675v-.522h.65c1.48 0 2.69-1.125 2.69-2.502-.01-1.62-1.05-2.133-1.83-2.376zm-4.02-1.269c-.51-.162-.82-.315-.82-1.098 0-.639.53-1.152 1.19-1.152h.65v2.574l-1.02-.324zm3.16 4.797h-.65V9.954l1.01.315c.51.162.82.315.82 1.098 0 .639-.53 1.161-1.18 1.161z",
    fill: "#1080FF",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.8a5ef5be91dba39b9757050d37b29c27.svg";
export { ForwardRef as ReactComponent };